import { StoreAction, StoreConfig } from '@input-web/configs/store/store.config';
import main from '@input-web/modules/main/stores/main.store';
import standard from '@input-web/modules/standard/stores/standard.store';
import user from '@input-web/modules/user/stores/user.store';
import { isObjectTypeValid } from '@util/utils/object.util';

const stores = { main, standard, user };

// #region Types
type AppStore = typeof stores;
type AppStoreInitial = { [Key in keyof AppStore]: AppStore[Key]['initial'] };
// #endregion

// #region Actions
const actions = {
  reset: (initials?: Partial<AppStoreInitial>) => {
    Object.entries(stores).forEach(([key, store]) => {
      const { actions: storeActions } = store satisfies StoreConfig;
      const passedInitial = initials?.[key as keyof AppStore];

      if (!isObjectTypeValid<StoreAction>(storeActions, ['reset'])) return;

      storeActions.reset?.(passedInitial);
    });
  },
};
// #endregion

const appStore = { ...stores, actions };

export default appStore;
